<form class="w-100 h-100 form" [formGroup]="blogForm" (ngSubmit)="sendData()">
  <mat-tab-group mat-align-tabs="start">
    <mat-tab label="Información de Vista General">
      <div class="row mx-0 my-3 p-0 w-100">
        <h4 class="text-center"> {{ sectionInfo.id ? 'Editar': 'Crear' }} Blog</h4>
        <div class="col-12 pl-xl-0 mt-2 mb-4 d-flex justify-content-center text-center">
          <div class="vs-outline-editCard btn-custom-banner" style="width: 50%">
            <img class="given-img" [src]="fileImg64" alt="img-banner" *ngIf="fileImg64">
            <div class="btn-custom-file w-100">
              <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
                <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
                <span class="my-2" *ngIf="!wrongSize">
                  Elegir imagen de 500px x 500px (imagen de preview)
                </span>
                <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
              </label>
              <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event)" />
            </div>
          </div>
        </div>
        <div class="col-6 pl-xl-0 mt-2 mb-4 d-flex justify-content-center text-center">
          <div class="vs-outline-editCard btn-custom-banner" style="width: 50%">
            <img class="given-img" [src]="fileUserImg64" alt="img-banner" *ngIf="fileUserImg64">
            <div class="btn-custom-file w-100">
              <label for="file-upload-user" class="custom-file-upload h-fit-content p-3">
                <mat-icon>{{!fileUserImg64 ? 'image': '' }} </mat-icon>
                <span class="my-2" *ngIf="!wrongSizeUserImg">
                  Elegir imagen de 100px x 100px (Foto de autor)
                </span>
                <span class="my-2 text-danger" *ngIf="wrongSizeUserImg">{{wrongSizeUserImg}}</span>
              </label>
              <input id="file-upload-user" type="file" accept="image/*" (change)="getUserImgBase64($event)" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Título (h1)</mat-label>
              <input matInput placeholder="Título de Blog" formControlName="title" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
          </div>
          <!--          <div class="mb-3">-->
          <!--            <mat-label>Fecha</mat-label>-->
          <!--            <mat-form-field appearance="outline" class="w-100" >-->
          <!--              <input matInput placeholder="DD-MM-YYYY" formControlName="date" disabled>-->
          <!--              <mat-error>Este campo es <b>Requerido</b></mat-error>-->
          <!--            </mat-form-field>-->
          <!--          </div>-->
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre de autor</mat-label>
              <input matInput placeholder="Nombre de autor" formControlName="name" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción (Breve)</mat-label>
              <textarea matInput placeholder="Descripción breve" formControlName="content" type="text" rows="7"
                max-rows="7" maxlength="200" required> </textarea>
              <mat-error *ngIf="blogForm.value.content.length > 200">Máximo de caracteres es de 200!</mat-error>
              <mat-error *ngIf="blogForm.get('content').hasError('required')">Este campo es <b>Requerido</b></mat-error>
              <mat-hint align="end"> {{blogForm.value.content.length}} / 200 caracteres!</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <!--        <div class="col-6">-->
        <!--          <div class="mb-3">-->
        <!--            <mat-form-field appearance="outline" class="w-100">-->
        <!--              <mat-label>Nombre de autor</mat-label>-->
        <!--              <input matInput placeholder="Nombre de autor" formControlName="name">-->
        <!--              <mat-error>Este campo es <b>Requerido</b></mat-error>-->
        <!--            </mat-form-field>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </mat-tab>
    <mat-tab label="Información de vista detallada">
      <div class="col-12 pl-xl-0 mt-2 mb-2 d-flex justify-content-center text-center">
        <div class="vs-outline-editCard btn-custom-banner" style="width: 50%">
          <img class="given-img mw-100" [src]="fileDetailImg" alt="img-banner" *ngIf="fileDetailImg">
          <div class="btn-custom-file w-100">
            <label for="file-upload-detail" class="custom-file-upload h-fit-content p-3">
              <mat-icon>{{!fileDetailImg ? 'image': '' }} </mat-icon>
              <span class="my-2" *ngIf="!wrongSizeDetail">
                Elegir imagen de 1200px x 800px (imagen de blog)
              </span>
              <span class="my-2 text-danger" *ngIf="wrongSizeDetail">{{wrongSizeDetail}}</span>
            </label>
            <input id="file-upload-detail" type="file" accept="image/*" (change)="getImgDetail64($event)" />
          </div>
        </div>
      </div>

      <div class="dv-blog-images">
        <div class="float-blog-button-container">
          <button mat-fab type="button" aria-label="Add" class="float-blog-button" (click)="createBlog();">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="estimateTemplate">
        </ng-container>
      </div>

      <div class="col-12 mt-2 chip-bottom-box">
        <mat-form-field class="example-chip-list" appearance="outline" class="w-100">
          <mat-label>Palabras Clave</mat-label>
          <mat-chip-list #chipList aria-label="Palabras Clave" required>
            <mat-chip *ngFor="let keyword of initialKeywordList" [selectable]="selectable" [removable]="removable"
              (removed)="remove(keyword)">
              {{keyword.title}}
              <button (click)="remove(keyword)" mat-icon-button *ngIf="removable">
                <mat-icon color="warn">cancel</mat-icon>
              </button>
            </mat-chip>
            <input placeholder="Nueva Palabra Clave" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($event)">
          </mat-chip-list>
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>


  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="blogForm.invalid">
      {{sectionInfo.id ? 'Editar' : 'Crear'}} Blog
    </button>
  </div>
</form>

<ng-template #estimateTemplate>
  <div *ngFor="let item of this.sectionInfo.information.contents, index as i">
    <div class="row mx-0 my-2 p-0 w-100">

      <div class="col-7 mt-2 mb-0">
        <quill-editor placeholder="Escriba aqui.." [(ngModel)]="item.content" [maxLength]="7800">
          <div quill-editor-toolbar class="w-100">
            <span class="ql-formats">
              <button class="ql-bold" [title]="'Bold'"></button>
              <button class="ql-italic" [title]="'Italic'"></button>
              <button class="ql-underline" [title]="'Underline'"></button>
              <button class="ql-strike" [title]="'Strike'"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-blockquote" [title]="'Blockquote'"></button>
              <button class="ql-image" [title]="'Image'"></button>
              <button class="ql-video" [title]="'Video'"></button>
              <select class="ql-header" [title]="'Header'">
                <option selected></option>
                <option value="1"></option>
                <option value="2"></option>
                <option value="3"></option>
                <option value="4"></option>
                <option value="5"></option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-align" [title]="'Justificación de texto'">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="bullet"></button>
            </span>
          </div>
        </quill-editor>
        <mat-error *ngIf="item.content.length > 7800">Máximo de caracteres es de 7800!</mat-error>
        <mat-hint align="end"> {{item.content.length}} / 7800 caracteres!</mat-hint>
      </div>

      <div class="col-5 px-0">

        <div class="row mx-0 p-0 w-100">
          <div class="col-8 mt-2 mb-0 px-0">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Título (h2)</mat-label>
              <input matInput placeholder="Título H2" [(ngModel)]="item.title" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
          </div>

          <div class="col-4 mt-4 dv-action-button px-0">
            <span style="margin-right: 5px; margin-top: 5px;">Orden: {{ i + 1 }}</span>
            <button type="button" class="vs-btn-crud" matTooltip="Subir" (click)="moveBlog(i, 1)">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button type="button" class="vs-btn-crud" matTooltip="Bajar" (click)="moveBlog(i, 2)">
              <mat-icon>arrow_downward</mat-icon>
            </button>
            <button type="button" class="vs-btn-crud" matTooltip="Eliminar" (click)="deleteBlog(i)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>

        <div class="row mx-0 p-0 w-100">
          <div class="col-12 ps-0 chip-box">
            <mat-form-field class="example-chip-list" appearance="outline" class="w-100">
              <mat-label>Subtítulo del Párrafo (h3)</mat-label>
              <mat-chip-list #chipList aria-label="Subtítulo del Párrafo (h3)" required>
                <mat-chip *ngFor="let itemH3 of item.h3s" [selectable]="selectable" [removable]="removable"
                  (removed)="removeH3(itemH3, i)">
                  {{itemH3.h3Description}}
                  <button (click)="removeH3(itemH3, i)" mat-icon-button *ngIf="removable">
                    <mat-icon color="warn">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input placeholder="Nueva Palabra Clave" [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="addH3($event, i)">
              </mat-chip-list>
            </mat-form-field>
          </div>
        </div>


      </div>

    </div>


  </div>
</ng-template>